export class Bom {
    constructor(
      public bom_id?: number,
      public productName?: string,
      public product_code?: string,
      public productDescription?: string,
      public company_id?: number,
      public bomMapping?: BomMapping[],
      public tbl_bomMappings?: BomMapping[]

    ) {
      this.bom_id = bom_id;
      this.productName = productName;
      this.product_code = product_code;
      this.productDescription = productDescription;
      this.company_id = company_id;
      this.bomMapping = bomMapping;
      this.tbl_bomMappings = bomMapping;
    }
  }

 export interface BomMapping {
    assetClass_id: number;
    assetCategories_id: number;
    item_id: number;
    quantity: number;
    company_id:number;
  }
  